export default {
  qrToPrint: [],
};
